var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 116h-116c-1.104 0-2-0.9-2-2v-108c0-1.104 0.896-2 2-2h116c1.1 0 2 0.896 2 2v108c0 1.1-0.9 2-2 2zM4 112h112v-104h-112v104z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 100h-112c-1.104 0-2-0.9-2-2s0.896-2 2-2h112c1.1 0 2 0.9 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116 24h-112c-1.104 0-2-0.896-2-2s0.896-2 2-2h112c1.1 0 2 0.896 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 108h-4c-1.104 0-2-0.9-2-2s0.896-2 2-2h4c1.104 0 2 0.9 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 108h-4c-1.104 0-2-0.9-2-2s0.896-2 2-2h4c1.104 0 2 0.9 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48 108h-4c-1.104 0-2-0.9-2-2s0.896-2 2-2h4c1.104 0 2 0.9 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108h-4c-1.104 0-2-0.9-2-2s0.896-2 2-2h4c1.1 0 2 0.9 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80 108h-4c-1.1 0-2-0.9-2-2s0.9-2 2-2h4c1.1 0 2 0.9 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96 108h-4c-1.1 0-2-0.9-2-2s0.9-2 2-2h4c1.1 0 2 0.9 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112 108h-4c-1.1 0-2-0.9-2-2s0.9-2 2-2h4c1.1 0 2 0.9 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16h-4c-1.104 0-2-0.896-2-2s0.896-2 2-2h4c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16h-4c-1.104 0-2-0.896-2-2s0.896-2 2-2h4c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44 16h-4c-1.104 0-2-0.896-2-2s0.896-2 2-2h4c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16h-4c-1.104 0-2-0.896-2-2s0.896-2 2-2h4c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16h-4c-1.1 0-2-0.896-2-2s0.9-2 2-2h4c1.1 0 2 0.896 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92 16h-4c-1.1 0-2-0.896-2-2s0.9-2 2-2h4c1.1 0 2 0.896 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108 16h-4c-1.1 0-2-0.896-2-2s0.9-2 2-2h4c1.1 0 2 0.896 2 2s-0.9 2-2 2z",
    fill: "#000000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42 84.592c-0.328 0-0.652-0.080-0.948-0.24-0.648-0.344-1.052-1.020-1.052-1.76v-46.184c0-0.736 0.404-1.412 1.052-1.76s1.432-0.316 2.048 0.092l35 23.088c0.56 0.372 0.9 1 0.9 1.672s-0.336 1.3-0.9 1.668l-35 23.096c-0.332 0.22-0.716 0.328-1.1 0.328zM44 40.12v38.756l29.368-19.38-29.368-19.376z",
    fill: "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo4);
export default __webpack_public_path__ + "static/media/Video-4.1f4f1ea3.svg";
export { ForwardRef as ReactComponent };